import { keyframes, css as styledCSS } from 'styled-components'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const scaleIn = keyframes`
    0% {
        opacity: 0;
        transform: scale(0);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
`

/**
 * UI animations for buttons, etc.
 */
enum CreationToolUIAnimation {
    FadeIn = 'CT_UI_ANIMATION_FADE_IN',
    PopIn = 'CT_UI_ANIMATION_POP_IN',
}

namespace CreationToolUIAnimation {
    /**
     * Returns css to use with styled components.
     */
    export function css(style: CreationToolUIAnimation): ReturnType<typeof styledCSS> {
        switch (style) {
            case CreationToolUIAnimation.FadeIn:
                return styledCSS`animation: ${fadeIn} 0.2s ease-out;`
            case CreationToolUIAnimation.PopIn:
                return styledCSS`animation: ${scaleIn} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);`
        }
    }
}

export default CreationToolUIAnimation
